import React from "react";
import { useAuth } from "../App";
import { CompanyAIAssistantPanel } from "../components/CompanyAIAssistant";

const AssistantPage = () => {
  const { currentCompany, fetchCompanies } = useAuth();
  return (
    <div className="space-y-4" data-testid="assistant-page">
      <div>
        <h1 className="text-3xl font-bold uppercase tracking-tight font-heading text-slate-900">AI Assistant</h1>
        <p className="text-slate-500 text-sm mt-1">
          {currentCompany ? `Tailoring ${currentCompany.name} (${currentCompany.code})` : "Open a company from System Admin to start chatting."}
        </p>
      </div>
      <CompanyAIAssistantPanel
        company={currentCompany}
        onCompanyUpdate={() => { if (fetchCompanies) fetchCompanies(); }}
      />
    </div>
  );
};

export default AssistantPage;
